import { callGetApi, callPostApi } from "../interceptor";

// Get Wallet Transactions List API function
export async function getAuditLogs(data) {
  try {
    const response = await callPostApi({
      url: `audit-logs/list`,
      body: data,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAuditLogDetails(id) {
  try {
    const response = await callGetApi({
      url: `audit-logs/${id}`,
    });
    return response;
  } catch (error) {
    throw error;
  }
}